import classNames from 'classnames';
import React from 'react';
import { ErrorCircleIcon } from '../../Components/Icons';
import { red, white } from '../../Styles/Colours';
import styles from './MedicationListErrors.module.css';
export var MedicationListErrors = function (props) {
    var errors = props.errors;
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.header },
            React.createElement("div", null, "Error")),
        React.createElement("div", { className: styles.body }, errors.map(function (it, index) { return (React.createElement("div", { key: it.errorCode + "-" + index, className: classNames(styles.row, styles.errorRow) },
            React.createElement(GeneralError, { message: it.errorMessage }))); }))));
};
var GeneralError = function (props) {
    return (React.createElement("div", { className: styles.generalError },
        React.createElement("div", { className: styles.informationHeader },
            React.createElement("div", { className: styles.icon },
                React.createElement(ErrorCircleIcon, { backgroundColour: red, color: white, size: '40' })),
            React.createElement("div", { className: styles.name }, props.message))));
};
